import {ExpandMore} from "@mui/icons-material";
import {Accordion, AccordionDetails, AccordionSummary, Grid, TextField} from "@mui/material";
import * as React from "react";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";

const GPSDetails = (props: any) => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'theftMisappropriate'});
    const { id } = useParams();
    const [isExpanded, setIsExpanded] = useState(true);
    const vehicle = props.vehicle;

    return (
        <Accordion defaultExpanded onChange={(_e,expanded) => {
            setIsExpanded(expanded); 
        }}>
            <AccordionSummary expandIcon={<ExpandMore/>}>
                <Grid item md={6} xs={6}>
                    {t("customerRADetails.gpsDetails") }
                </Grid>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container columnSpacing={3} rowSpacing={1}>
                    <Grid container item xs={12} columnSpacing={3} rowSpacing={1}>
                        <Grid item  xs={3}>
                            <TextField
                                fullWidth
                                disabled={true}
                                id="connected"
                                label={t("gpsDetails.connected")}
                                type="text"
                                InputLabelProps={{shrink: true}}
                                value={""}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                disabled={true}
                                id="connectionType"
                                label={t("gpsDetails.connectionType")}
                                type="text"
                                InputLabelProps={{shrink: true}}
                                value={""}
                            />
                        </Grid>
                    </Grid>
                    <Grid item  xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="installPrima"
                            label={t("gpsDetails.installPrima")}
                            type="text"
                            value={vehicle?.imeiPrimary ? vehicle.imeiPrimary : ""}
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item  xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="installGhost1"
                            label={t("gpsDetails.installGhost1")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            value={""}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="installGhost2"
                            label={t("gpsDetails.installGhost2")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            value={""}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="installGhost3"
                            label={t("gpsDetails.installGhost3")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            value={""}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="primaAtt"
                            label={t("gpsDetails.primaAtt")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            value={""}
                        />
                    </Grid>
                    <Grid item  xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="ghost1Att"
                            label={t("gpsDetails.ghost1Att")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            value={""}
                        />
                    </Grid>
                    <Grid item  xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="ghost2Att"
                            label={t("gpsDetails.ghost2Att")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            value={""}
                        />
                    </Grid>
                    <Grid item  xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="ghost3Att"
                            label={t("gpsDetails.ghost3Att")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            value={""}
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default GPSDetails;